export interface IDeviceUserAgent extends Object {
  isDeviceUserAgentLoading: boolean;
  isMobile: boolean;
  userAgent: string;
}

export const DEFAULT_DEVICE_USER_AGENT: Readonly<IDeviceUserAgent> = {
  isDeviceUserAgentLoading: false,
  isMobile: false,
  userAgent: '',
};